module.exports = __webpack_public_path__ + "static/img/0.b3bbd8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/0.jpg
// module id = 4rpC
// module chunks = 1